const SIZE = 200
const CX = SIZE / 2
const CY = SIZE / 2
const RADIUS = 82
const STROKE = 10

// Arc from startDeg to endDeg, clockwise (sweep=1)
function arcPath(startDeg: number, endDeg: number): string {
  const toRad = (d: number) => (d * Math.PI) / 180
  const sx = CX + RADIUS * Math.cos(toRad(startDeg))
  const sy = CY + RADIUS * Math.sin(toRad(startDeg))
  const ex = CX + RADIUS * Math.cos(toRad(endDeg))
  const ey = CY + RADIUS * Math.sin(toRad(endDeg))
  // Clockwise sweep from startDeg to endDeg
  const sweep = ((endDeg - startDeg) + 360) % 360
  const largeArc = sweep > 180 ? 1 : 0
  return `M ${sx} ${sy} A ${RADIUS} ${RADIUS} 0 ${largeArc} 1 ${ex} ${ey}`
}

// Full 3/4 arc: 135° → clockwise 270° → 45°
const BG_PATH = arcPath(135, 405) // 405 = 45 + 360 to force clockwise large arc

interface UnitCardProps {
  id: string
  name: string
  completedTopics: number
  totalTopics: number
  onClick?: () => void
}

export function UnitCard({ id, name, completedTopics, totalTopics, onClick }: UnitCardProps) {
  const progress = totalTopics > 0 ? completedTopics / totalTopics : 0
  const progressEndDeg = 135 + progress * 270

  return (
    <div className="relative cursor-pointer" style={{ width: SIZE, height: SIZE }} onClick={onClick}>
      <svg
        width={SIZE}
        height={SIZE}
        className="absolute inset-0"
        aria-hidden="true"
      >
        {/* Background track */}
        <path
          d={BG_PATH}
          fill="none"
          stroke="var(--color-muted)"
          strokeWidth={STROKE}
          strokeLinecap="round"
        />
        {/* Progress fill */}
        {progress > 0 && (
          <path
            d={arcPath(135, progressEndDeg)}
            fill="none"
            stroke="#22c55e"
            strokeWidth={STROKE}
            strokeLinecap="round"
          />
        )}
      </svg>

      {/* Card content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-1 px-4">
        <span className="text-sm font-semibold text-center leading-tight">
          {name}
        </span>
        <span className="text-xs text-muted-foreground text-center">
          {completedTopics}/{totalTopics} topics completed
        </span>
      </div>
    </div>
  )
}
